import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {BacnetDataPoint} from "../../../../domain/device.interface";
import {MatSort} from "@angular/material/sort";
import {BacnetDeviceService} from "../../../../services/bacnet-device.service";
import {NotificationService} from "../../../../services/notification.service";
import {BacnetDataPointAPI, BacnetDataPointConfig} from "../../../../domain/bacnet-datapoint";
import {interval, Subscription} from "rxjs";
import {BacnetDevice} from "../../../../domain/bacnet-device";
import {BacnetDatapointsScanResult} from "../../../../domain/bacnet-scan-result";

const PENDING_ADD_STATUS = "PENDING_ADD";
const PENDING_UPDATE_STATUS = "PENDING_UPDATE_POLLING_STATUS";
const PENDING_DELETE_STATUS = "PENDING_DELETE";
const DEPLOYED_STATUS = "DEPLOYED";
const UNDEPLOYED_STATUS = "UNDEPLOYED";

@Component({
  selector: 'eis-gateway-bacnet-datapoint-configurator-table',
  templateUrl: './bacnet-datapoint-configurator-table.component.html',
  styleUrls: ['./bacnet-datapoint-configurator-table.component.scss']
})
export class BacnetDatapointConfiguratorTableComponent implements OnChanges, AfterViewInit, OnInit {

  @ViewChild(MatSort) sort: MatSort;

  @Input()
  public gatewaySerial: string

  @Input()
  device: BacnetDevice | null;


  @Output()
  closeDrawerEvent: EventEmitter<void> = new EventEmitter();

  public scanningDeviceDataPoints: boolean;
  public dataPointsDataSource = new MatTableDataSource<BacnetDataPoint>([]);
  public displayedColumns: string[] = ['select', 'dataType', 'value', 'unit', 'description', 'pollingIntervalSeconds']

  public scanDatapointsSubscription: Subscription;
  private oldDatapointsListState: BacnetDataPoint[];
  areAllDatapointsSelected: boolean = false;


  constructor(private bacnetService: BacnetDeviceService,
              private notificationService: NotificationService,) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['device']) {
      this.getDatapoints()
      this.areAllDatapointsSelected = false
    }
  }


  ngAfterViewInit(): void {
    this.dataPointsDataSource.sort = this.sort;
  }

  ngOnInit(): void {
  }


  getDatapoints() {
    if (this.device == null) {
      return
    }

    this.dataPointsDataSource.data = []
    this.bacnetService.getDatapointScanResult(this.gatewaySerial, this.device.id.toString())
      .subscribe(datapointsScanResult => {

        if (datapointsScanResult.scanStatus !== 'done') {
          this.scanningDeviceDataPoints = true
          return;
        }

        this.bacnetService.getDatapointConfigList(this.device!!.id.toString())
          .subscribe(datapointCOnfigList => {

            this.dataPointsDataSource.data = datapointsScanResult.datapointList.map(datapoint => {
              const datapointConfig = datapointCOnfigList.find(config => config.datapointId == datapoint.id);
              return this.toCoreModel(datapoint, datapointConfig)
            })

            this.oldDatapointsListState = JSON.parse(JSON.stringify(this.dataPointsDataSource.data))

            this.dataPointsDataSource.sort = this.sort;


          })


        //hide spinner
        this.scanningDeviceDataPoints = false
        if (this.scanDatapointsSubscription) {
          this.scanDatapointsSubscription.unsubscribe()
        }

      })
  }

  private toCoreModel(dataPointAPI: BacnetDataPointAPI, config?: BacnetDataPointConfig): BacnetDataPoint {
    return {
      id: dataPointAPI.id,
      deviceId: dataPointAPI.deviceName,
      dataType: dataPointAPI.objectName,
      key: dataPointAPI.key,
      value: dataPointAPI.value,
      unit: dataPointAPI.units,
      description: dataPointAPI.description,
      deploymentStatus: config?.deploymentStatus ?? UNDEPLOYED_STATUS,
      pollingIntervalSeconds: config?.pollingIntervalSeconds ?? 60

    }
  }

  startScanFOrDatapoints() {
    this.scanningDeviceDataPoints = true
    this.bacnetService.startScanDeviceDatapoints(this.gatewaySerial, this.device!!.id.toString())//  todo tenant
      .subscribe(result => {
          console.log("result:")
          console.log(result)
          if (result) {
            this.scanDatapointsSubscription = interval(5 * 1000).subscribe(_ => this.getDatapoints());

          }

        },
        error => {
          console.log("error:", error)
          this.notificationService.failure("Error, please check the logs")
        }
      )
  }

  toggleAllRowsSelected() {
    if (this.areAllDatapointsSelected) {
      //Selected+ toggle =unselect all
      this.dataPointsDataSource.data
        .filter(datapoint => this.isSelected(datapoint))
        .forEach(datapoint => {
          this.toggleRowSelected(datapoint)
        })
    } else {
      //UnSelected+ toggle = select all
      this.dataPointsDataSource.data
        .filter(datapoint => !this.isSelected(datapoint))
        .forEach(datapoint => {
          this.toggleRowSelected(datapoint)
        })
    }
    this.areAllDatapointsSelected = !this.areAllDatapointsSelected
  }


  toggleRowSelected(dataPoint: BacnetDataPoint) {
    dataPoint.deploymentStatus = this.isSelected(dataPoint) ? PENDING_DELETE_STATUS : PENDING_ADD_STATUS
  }


  isSelected(row: BacnetDataPoint) {
    return [PENDING_ADD_STATUS, PENDING_UPDATE_STATUS, DEPLOYED_STATUS].includes(row.deploymentStatus)
  }

  isDeleted(row: BacnetDataPoint) {
    return PENDING_DELETE_STATUS === row.deploymentStatus
  }

  isNew(row: BacnetDataPoint) {
    return [PENDING_ADD_STATUS].includes(row.deploymentStatus)
  }

  closeDrawer() {
    this.closeDrawerEvent.emit()
  }


  saveChanges() {

    let newConfigList: BacnetDataPointConfig[] = this.dataPointsDataSource.data.map(datapoint => {

        const oldDatapoint = this.oldDatapointsListState.find(it => it.id === datapoint.id);

        const deploymentStatus = oldDatapoint?.pollingIntervalSeconds != datapoint.pollingIntervalSeconds ? PENDING_UPDATE_STATUS : datapoint.deploymentStatus;
        return {
          deviceId: this.device!!.id,
          datapointId: datapoint.id,
          deploymentStatus: deploymentStatus,
          pollingIntervalSeconds: datapoint.pollingIntervalSeconds,
        }
      }
    )


    let request = {
      addList: newConfigList.filter(config => config.deploymentStatus === PENDING_ADD_STATUS),
      updateList: newConfigList.filter(config => config.deploymentStatus === PENDING_UPDATE_STATUS),
      deleteList: newConfigList.filter(config => config.deploymentStatus === PENDING_DELETE_STATUS),

    }

    this.bacnetService.saveDatapointConfigList(request).subscribe(async result => {
      if (result) {
        this.closeDrawer()
        await this.notificationService.success("bacnet-preview-changes.apply.success")
      }
    })


  }


}
